'use client'
import { useEffect } from 'react';
import dynamic from 'next/dynamic'
import LoginForm from './LoginForm'
import AuthTop from '@/Component/Auth/AuthTop'
import AuthBottom from '@/Component/Auth/AuthBottom';
import { useTranslation } from '@/Utils/Hooks/useTranslate';
import { useLoading } from '@/Utils/Hooks/useLoading';
import SkeletonLoader from '@/Layout/SkeletonLoader';
import Link from 'next/link';
import { useDispatch } from 'react-redux';
import { getUserDetails } from '@/lib/Features/UserDetails/userDetails'

const GoogleLogin = dynamic(() => import('./SocialLogin/GoogleLogin'), { ssr: false });

const Login = (props) => {
    const { role } = props;
    const { translations, locale } = useTranslation();
    const { skeletonLoading, startSkeletonLoading, stopSkeletonLoading } = useLoading();
    const dispatch = useDispatch();

    useEffect(() => {
        startSkeletonLoading();
        setTimeout(() => {
            stopSkeletonLoading();
            dispatch(getUserDetails(null));
        }, 1000);
    }, []);

    return (
        <div className='mx-auto max-w-xl flex flex-col h-full'>
            <AuthTop skeletonLoading={skeletonLoading} logoutBtn={false} translations={translations} />
            <span className="kicker mb-3">{translations.loginSubTitle || 'Welcome back'}</span>
            <h1 className='text-display font-bold lg:text-4xl md:text-3xl sm:text-2xl text-xl mb-3 !leading-[1.05] text-neutral-900'>
                {skeletonLoading ? <SkeletonLoader height={60} rows={1} /> : (
                    <>
                        {translations.loginTitle}
                        <span className="relative inline-block ml-2">
                            <span aria-hidden className="absolute -bottom-1 left-0 right-0 h-3 bg-gradient-to-r from-primary/25 to-accent/25 rounded-full -z-10"></span>
                        </span>
                    </>
                )}
            </h1>
            {skeletonLoading ? <SkeletonLoader width="276" height={24} rows={1} /> :
                <p className='flex items-center text-neutral-600 text-sm'>
                    {skeletonLoading ? <SkeletonLoader width="300" height={24} rows={1} /> : <>
                        {translations.notAccount} &nbsp;
                        <Link href="/register" className='font-semibold text-primary hover:text-primaryDark transition-colors'>{translations.registerNow}</Link></>
                    }
                </p >}

            <div className='flex-1'>
                <LoginForm translations={translations} skeletonLoading={skeletonLoading} locale={locale} role={role} />
                {role == 'admin' ? null :
                    <>
                        <div className='relative my-5'>
                            <span className='bg-gradient-to-l from-[#ADB5BD]/[.2] to-transparent h-0.5 block absolute left-0 w-[calc(50%-55px)] top-[50%] translate-y-[-50%]'></span>
                            <span className='px-2 2xl:text-sm text-xs font-normal text-center flex justify-center'>{skeletonLoading ? <SkeletonLoader width="50" height={20} rows={1} /> : translations.or}</span>
                            <span className='bg-gradient-to-r from-[#ADB5BD]/[.2] to-transparent h-0.5 block absolute right-0 w-[calc(50%-55px)] top-[50%] translate-y-[-50%]'></span>
                        </div>
                        {skeletonLoading ? <SkeletonLoader height={50} rows={1} /> :
                            <GoogleLogin translations={translations} locale={locale} />}
                    </>
                }
            </div>
        </div>
    )
}

export default Login
